module.exports = __webpack_public_path__ + "static/media/book.4d9f05b5.svg";